<script lang="ts">
  export let svgStyles: string = ''
</script>

<svg viewBox="0 0 304 305" fill="none" xmlns="http://www.w3.org/2000/svg" class={svgStyles}>
  <circle cx="152" cy="152.5" r="151.5" stroke="black" />
</svg>
